import {
  Thermometer, Droplets, Tv, Lock, Car, Coffee, Utensils, Bed, Bath, Wind,
  Flame, Zap, Key, Sun, Camera, Music, Shirt, Package, Trash2, Wifi, Info,
  MapPin, ShoppingBag, Bike, Wine, Navigation, DollarSign, Heart, Star,
} from "lucide-react";

// Mappa id icona (coerente con ICON_OPTIONS admin) -> componente + colore.
const MAP = {
  thermometer: { Icon: Thermometer, color: "#EF4444" },
  droplets: { Icon: Droplets, color: "#0EA5E9" },
  tv: { Icon: Tv, color: "#6366F1" },
  lock: { Icon: Lock, color: "#64748B" },
  car: { Icon: Car, color: "#2563EB" },
  coffee: { Icon: Coffee, color: "#92400E" },
  utensils: { Icon: Utensils, color: "#EA580C" },
  bed: { Icon: Bed, color: "#8B5CF6" },
  bath: { Icon: Bath, color: "#06B6D4" },
  wind: { Icon: Wind, color: "#0891B2" },
  flame: { Icon: Flame, color: "#F97316" },
  zap: { Icon: Zap, color: "#EAB308" },
  key: { Icon: Key, color: "#D97706" },
  sun: { Icon: Sun, color: "#F59E0B" },
  camera: { Icon: Camera, color: "#475569" },
  music: { Icon: Music, color: "#DB2777" },
  shirt: { Icon: Shirt, color: "#14B8A6" },
  package: { Icon: Package, color: "#78716C" },
  trash: { Icon: Trash2, color: "#64748B" },
  wifi: { Icon: Wifi, color: "#3B82F6" },
  info: { Icon: Info, color: "#3B82F6" },
  map: { Icon: MapPin, color: "#16A34A" },
  shopping: { Icon: ShoppingBag, color: "#DB2777" },
  bike: { Icon: Bike, color: "#16A34A" },
  wine: { Icon: Wine, color: "#E11D48" },
  navigation: { Icon: Navigation, color: "#0EA5E9" },
  dollar: { Icon: DollarSign, color: "#16A34A" },
  heart: { Icon: Heart, color: "#F43F5E" },
  star: { Icon: Star, color: "#EAB308" },
};

export const getManualIcon = (id) => MAP[id] || MAP.info;
